import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { HttpClient, provideHttpClient } from '@angular/common/http';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { Auth, signInAnonymously } from 'firebase/auth';
import { environment } from './environments/environment';
import { importProvidersFrom } from '@angular/core';
import { routes } from './app/app.routes';
import './global.css';
import { provideRouter } from '@angular/router';
import { TranslateLoader, TranslateModule, TranslateService, TranslateStore } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient): TranslateLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    provideRouter(routes),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideHttpClient(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      })
    )
  ]
})
    // provideAuth(() => getAuth()),
    // {
    //   provide: 'AuthInitializer',
    //   useFactory: (auth: Auth) => {
    //     return () => signInAnonymously(auth)
    //       .then(credentials => {
    //         console.log('Anonymous authentication successful:', credentials.user.uid);
    //         return credentials.user;
    //       })
    //       .catch(error => {
    //         console.error('Anonymous authentication failed', error);
    //         throw error;
    //       });
    //   },
    //   deps: [getAuth],
    //   multi: true
    // }

  .catch((err) => console.error(err));
